export const CallAdExtension = {
  properties: {
    'bulk-upload-type': {
      type: 'string',
      value: 'CallAdExtension',
    },
  },
};
